
import $ from 'jquery';
import appAjax from '../helpers/ajax';

function htmlImagePreview(file) {
  if (file.url_preview) {
    return (
      <div className='col-4'>
        <img
          src={file.url_preview}
          className="img-fluid"
          style={{ width: '100%', borderRadius: 3 }}
          alt="preview"
        />
      </div>
    );
  }
  return null;
}

function FileList({ files, page }) {
  return (
    <div className="file_list_container mb-1" data-page={page || 1}>
      {files.map(file => (
        <div key={file.created_at} style={{borderBottom: '1px solid #DDD', paddingBottom: 10}}>
          <div style={{ marginBottom: 5, color: "#AAA", padding: 3 }}>
            <small><i class="fa fa-calendar"></i> {file.created_at} | Size: {file.file_size}</small>
          </div>
          <div className='row g-0' style={{ marginBottom: 5 }}>
            {htmlImagePreview(file)}
            <div className={'col-8' + (file.url_preview ? ' pl-0' : '')}>
              <a
                href={file.url}
                target="_blank"
                style={{
                  fontSize: '10pt',
                  display: "inline-block",
                  textOverflow: "ellipsis",
                  textWrap: "nowrap",
                  maxWidth: '100%',
                  overflow: "hidden",
                  verticalAlign: "top",
                  marginBottom: 5,
                }}
              >
                <i className="fa fa-file" /> {file.file_name}
              </a>
              <div className="text-muted" style={{ verticalAlign: "top" }}>{file.file_title}</div>
            </div>
          </div>
        </div>
      ))}

      { files.length > 0 ? (
        <div style={{ textAlign: "center", marginTop: 10 }}>
          <a href="#" className="btn btn-secondary btn-sm btn_loadmore"><i className='fa fa-chevron-down'></i> More</a>
        </div>
      ) : null }
      
    </div>
  );
}

const onClickNext = (e) => {
  e.preventDefault();

  var elParent = $(e.target).closest('.file_list_container');
  var page = parseInt(elParent.attr('data-page'));

  $('.btn_loadmore', elParent).remove();

  appAjax.listFiles(page + 1);
};

const onClickPrev = (e) => {
  
}

const onClickItem = (e) => {
  // e.preventDefault();
  // console.log('The link was clicked.');
};

export function initFileList(dom) {
  // console.log('initFileList');
  $('.btn_loadmore', dom).on('click', onClickNext);
};

export default FileList;
